import CheckBoxMade from '../../CheckBox'
import InputComponent from '../../Input'
import SelectOptions from '../../Select'
import Base from '../index'
import { Form, ItemGrid } from './style'

const ModalTransform = () => {
  return (
    <Base title={'Transformar em produto'} width={'820px'} height={'80%'}>
      <Form>
        <InputComponent label={'Código'} placeholder={'Id'} />
        <InputComponent label={'Nome'} placeholder={'Nome'} />
        <SelectOptions />
        <InputComponent label={'Fração'} placeholder={'Ex: 2'} />
        <InputComponent label={'Custo'} placeholder={'R$ 00,00'} />
        <InputComponent label={'Preço do concorrente'} placeholder={'R$ 00,00'} />

        <CheckBoxMade />

        <ItemGrid start={5}>
          <InputComponent label={''} />
        </ItemGrid>
      </Form>
    </Base>
  )
}
export default ModalTransform
